exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group input[data-v-a0b9db06] {\n  width: 100%;\n  text-align: left !important;\n}\n.form-group input[data-v-a0b9db06]::-moz-placeholder {\n  color: lightgray;\n}\n.form-group input[data-v-a0b9db06]:-ms-input-placeholder {\n  color: lightgray;\n}\n.form-group input[data-v-a0b9db06]::placeholder {\n  color: lightgray;\n}\n", ""]);

// exports
